import { render } from "./ItemMoverFloatingWindow.vue?vue&type=template&id=4d3df61a&scoped=true"
import script from "./ItemMoverFloatingWindow.vue?vue&type=script&lang=js"
export * from "./ItemMoverFloatingWindow.vue?vue&type=script&lang=js"

import "./ItemMoverFloatingWindow.vue?vue&type=style&index=0&id=4d3df61a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4d3df61a"

export default script